module.exports = __webpack_public_path__ + "static/media/minus.22e78f92.svg";